import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Pages.css';
import './css/Legal.css';
import './css/Fonts.css';
import { Col, Container, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { legalDocs } from '../content';

// Marks a value that still has to be filled in before the page is final. Renders
// highlighted in brackets so gaps are obvious on the live page; search the code
// for "<Fill>" to find every one.
export function Fill({ children }) {
  return <span className="legal-fill">[{children}]</span>;
}

// Shared shell for the legal documents: page header, effective date, a sidebar
// linking the sibling documents, and a readable single-column body.
function LegalPage({ title, lead, effectiveDate, children }) {
  return (
    <div className="page">
      <header className="page-header">
        <Container>
          <p className="page-eyebrow">Legal</p>
          <h1 className="page-title">{title}</h1>
          {lead && <p className="page-lead">{lead}</p>}
        </Container>
      </header>

      <Container className="page-section">
        <Row className="g-5">
          <Col lg={3}>
            <nav className="legal-nav" aria-label="Legal documents">
              <p className="legal-nav-title">Legal documents</p>
              <ul>
                {legalDocs.map((doc) => (
                  <li key={doc.path}>
                    <NavLink to={doc.path}>{doc.title}</NavLink>
                  </li>
                ))}
              </ul>
            </nav>
          </Col>
          <Col lg={9}>
            <article className="legal-body">
              {effectiveDate && <p className="legal-effective">Effective date: {effectiveDate}</p>}
              {children}
            </article>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default LegalPage;
